"use client";

import { useCurrentUser } from "@zapier/client";
import {
  useIdentifyToFullStory,
  useInstallFullStory,
} from "@zapier/react-fullstory";

/**
 * Boots FullStory and identifies the current user so client interactions
 * (e.g. `spark_carousel_collapse_toggle`) are captured in FullStory sessions.
 *
 * The `@zapier/react-fullstory` package self-gates: both hooks are effect-based
 * (SSR-safe) and installation only happens in real production (disabled on
 * staging, preview deploys, and for internal `zapier.com` emails). The org id
 * is baked into the package, so no config is required here.
 */
export function FullStory() {
  useInstallFullStory();

  const { user } = useCurrentUser();

  const displayName = user
    ? [user.firstName, user.lastName].filter(Boolean).join(" ")
    : undefined;

  useIdentifyToFullStory(
    user
      ? {
          id: String(user.id),
          email: user.email ?? "",
          displayName: displayName || undefined,
        }
      : undefined,
  );

  // eslint-disable-next-line unicorn/no-null -- React components return null to render nothing
  return null;
}
